import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: any = {
  isLoading: false,
  isHomePageLoaded: false,
  isTextLoader: false,
  CDPScriptLoadedStatus: false,
  isMultiTA: false,
  newEprLoaded: false,
  isEnrollmentContentLoaded: false,
};
const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    showEnrollmentContent: (state) => ({
      ...state,
      isEnrollmentContentLoaded: true,
    }),
    hideEnrollmentContent: (state) => ({
      ...state,
      isEnrollmentContentLoaded: false,
    }),
    showLoader: (state) => ({
      ...state,
      isLoading: true,
    }),
    hideLoader: (state) => ({
      ...state,
      isLoading: false,
    }),
    setHomePageLoad: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isHomePageLoaded: action.payload,
    }),
    setCDPScriptLoadedStatus: (state, action: PayloadAction<boolean>) => ({
      ...state,
      CDPScriptLoadedStatus: action.payload,
    }),
    setScreenerID: (state, action: PayloadAction<string>) => ({
      ...state,
      screenerID: action.payload,
    }),
    setScreenerNewID: (state, action: PayloadAction<string>) => ({
      ...state,
      screenerNewID: action.payload,
    }),
    setScreenerAtt: (state, action: PayloadAction<string>) => ({
      ...state,
      screenerAtt: action.payload,
    }),
    setConcatinatedScreener: (state, action: PayloadAction<string>) => ({
      ...state,
      concatinatedScreener: action.payload,
    }),
    setCounter: (state, action: PayloadAction<number>) => ({
      ...state,
      counter: action.payload,
    }),
    setMultiTALoad: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isMultiTA: action.payload,
    }),
    setMultiTAEPRLoaded: (state, action: PayloadAction<boolean>) => ({
      ...state,
      newEprLoaded: action.payload,
    }),
    setPreviousScreenerId: (state, action: PayloadAction<string | null>) => ({
      ...state,
      previousScreenerID: action.payload,
    }),
  },
});
// Export actions
export const {
  showLoader,
  hideLoader,
  setHomePageLoad,
  setCDPScriptLoadedStatus,
  setScreenerID,
  setScreenerNewID,
  setScreenerAtt,
  setConcatinatedScreener,
  setCounter,
  setMultiTALoad,
  setMultiTAEPRLoaded,
  setPreviousScreenerId,
  showEnrollmentContent,
  hideEnrollmentContent,
} = loaderSlice.actions;
// Export reducer
export default loaderSlice.reducer;
